import { render, staticRenderFns } from "./WfConsumerCorpList.vue?vue&type=template&id=1d7212a4&scoped=true&"
import script from "./WfConsumerCorpList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerCorpList.vue?vue&type=style&index=0&id=1d7212a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7212a4",
  null
  
)

export default component.exports